<template>
    <div class='headerSerc' :style="
    'background-image: linear-gradient(to right, ' + item.bgColor.color[0].item + ', ' + item.bgColor.color[1].item + ');'">
        <div class='headerSerc-logo' v-if='item.logoConfig.url'>
            <img :src='item.logoConfig.url'>
        </div>
        <div class='headerSerc-search' :style='{justifyContent: item.txtStyle.type === 0? "left" : item.txtStyle.type === 1? "center" : "right" }' :class='{"headerSerc-search-active": item.boxStyle.type === 0}'>
            <div>
                <i class="el-icon-search"></i>
                <span>搜索商品</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'headerSerc',
    props:{
        item:{
            type:Object,
            default:{}
        }
    },
    data() {
        return {

        };
    }
};
</script>

<style scoped lang='scss'>
.headerSerc {
    width: 100%;
    height: 48px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    .headerSerc-logo{
        width: 100px;
        height: 30px;
        padding-right: 10px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .headerSerc-search{
        flex: 1;
        height: 30px;
        padding: 0 10px;
        background-color: #ffffff;
        color: #a6a6c4;
        font-size: 14px;
        display: flex;
        align-items: center;
        span{
            margin-left: 5px;
        }
    }
    .headerSerc-search-active{
        border-radius: 15px;
    }

}
</style>